export default __webpack_public_path__ + "static/media/close-white.08d99a76.svg";